import i18n from '@/plugins/i18n'

export const NO_CONFIRMED = 1
export const SCHEDULED = 2
export const PAYED = 3
export const IN_PROGRESS = 4
export const FINISHED = 5
export const CLOSED = 6
export const CANCELLED_PATIENT = 7
export const CANCELLED_PROF = 8
export const TECHNICAL_ERROR = 10
export const PAYMENT_PLATFORM_ERROR = 11
export const PENDING_PATIENT = 12
export const FILLING_REPORT = 13
export const CLOSED_WITHOUT_REPORT = 14
export const EXPIRED = 15
export const POSTPONED = 16
export const PHONE_ATTENDED = 17
export const CHARGED_PROFESSIONAL = 18
export const PATIENT_NOT_PRESENTED = 19

export const CONSULTATIONS_STATES_TITLE = {
    [CLOSED_WITHOUT_REPORT]: i18n.t('appointmentStates.finishedWithoutReport'),
    [PHONE_ATTENDED]: i18n.t('appointmentStates.attendedOutsidePlatform'),
    [CHARGED_PROFESSIONAL]: i18n.t('appointmentStates.chargedByProfessional'),
    [CLOSED]: i18n.t('appointmentStates.finishedWithReport'),
    [EXPIRED]: i18n.t('appointmentStates.expiredRequest'),
    [PATIENT_NOT_PRESENTED]: i18n.t('appointmentStates.patientDoesntShowUp'),
    [CANCELLED_PATIENT]: i18n.t('appointmentStates.appointmentCancelledPatient'),
    [CANCELLED_PROF]: i18n.t('appointmentStates.appointmentCancelledProfessional'),
    [EXPIRED]: i18n.t('appointmentStates.expired')
}

export function getPastStates () {
    return [FINISHED, CLOSED, CANCELLED_PATIENT, CANCELLED_PROF, CLOSED_WITHOUT_REPORT, EXPIRED, PHONE_ATTENDED, CHARGED_PROFESSIONAL, PATIENT_NOT_PRESENTED]
}
export function getPastStatesTitle (state) {
    return CONSULTATIONS_STATES_TITLE[state]
}


// WEBPACK FOOTER //
// ./src/constants/db/consultationStates.js